<template>
  <div v-if="projectOneEnabled" class="cart-select-p1">
    <a qaid="customize-btn" class="button button--secondary button--block" :href="projectOneLink" target="_blank">
      <i class="material-icons colorWheel" />
      <span v-html="bp('customize')" />
    </a>
  </div>
</template>
<script>
export default {
  name: 'PdpCustomizeProductButton',
  props: {
    projectOneUrl: {
      type: String,
      default: '',
    },
    customProductStartingPoint: {
      type: String,
      default: '',
    },
    siteLocale: {
      type: String,
      default: '',
    },
    isProjectOneConfiguratorActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    projectOneEnabled() {
      return (
        (this.isProjectOneConfiguratorActive &&
          this.customProductStartingPoint &&
          this.customProductStartingPoint.length > 0) ||
        (this.projectOneUrl && this.projectOneUrl.length > 0)
      );
    },
    projectOneLink() {
      return this.isProjectOneConfiguratorActive &&
        this.customProductStartingPoint &&
        this.customProductStartingPoint.length > 0
        ? '/' + this.siteLocale + '/project-one-builder/?packageId=' + this.customProductStartingPoint
        : this.projectOneUrl;
    },
  },
};
</script>
